module.exports = __webpack_public_path__ + "img/307.a41cfb37.png";